export default __webpack_public_path__ + "static/media/brandontext-black.b05ba58d.ttf";